import React, { useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { Caption, Input, MaskedInput, RegularButton } from 'fronton-react';
import { ContactFormData } from '../../types';
import { formStyles } from './styles';
import { validation } from './form-config';

export const Form = ({
	onSubmit,
	loading,
	fetched,
}: {
	onSubmit: (contact: ContactFormData) => void;
	loading: boolean;
	fetched: boolean;
}) => {
	const { control, handleSubmit, reset } = useForm<ContactFormData>({});

	useEffect(() => {
		if (fetched) {
			reset();
		}
	}, [fetched, reset]);

	return (
		<form onSubmit={handleSubmit(onSubmit)} className={formStyles}>
			<Controller
				name="name"
				control={control}
				rules={validation.name}
				render={({ field, fieldState: { error } }) => (
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore
					<Input
						fullWidth
						placeholder="Имя"
						error={!!error}
						caption={error && <Caption error message={error.message} />}
						{...field}
					/>
				)}
			/>
			<Controller
				name="phone"
				control={control}
				rules={validation.phone}
				render={({ field, fieldState: { error } }) => (
					<MaskedInput
						mask="+7 (999) 999-99-99"
						{...field}
						placeholder="Телефон"
						autoComplete="tel"
						error={!!error}
						caption={error && <Caption error message={error.message} />}
					/>
				)}
			/>
			<RegularButton size="l" type="submit" disabled={loading}>
				Отправить
			</RegularButton>
		</form>
	);
};
